(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.kGRequest = factory());
})(this, function () {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function forEach(obj, fn) {
    if (obj === null || typeof obj === 'undefined') {
      return;
    }

    if (_typeof(obj) !== 'object') {
      obj = [obj];
    }

    if (isArray(obj)) {
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }

  function isArray(val) {
    return Object.prototype.toString.call(val) === '[object Array]';
  }

  function trim(str) {
    if (isEmpty(str)) {
      return "";
    }

    return str.replace(/^\s*/, '').replace(/\s*$/, '');
  }

  function isEmpty(obj) {
    if (typeof obj !== 'undefined' && obj !== null && obj !== "") {
      return false;
    }

    return true;
  }
  /**
   *深度合并对象
   *
   * @returns
   */


  function deepMerge()
  /* obj1, obj2, obj3, ... */
  {
    var result = {};

    function assignValue(val, key) {
      if (_typeof(result[key]) === 'object' && _typeof(val) === 'object' && !val instanceof Array) {
        result[key] = deepMerge(result[key], val);
      } else if (_typeof(val) === 'object' && !val instanceof Array) {
        result[key] = deepMerge({}, val);
      } else {
        result[key] = val;
      }
    }

    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }

    return result;
  }
  /**
   * 将一个对象的方法和属性扩展到另外一个对象上，并指定上下文
   *
   * @param {*} a
   * @param {*} b
   * @param {*} thisArg
   * @returns
   */


  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === 'function') {
        a[key] = val.bind(thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }
  /**
   * 将对象变成 key=value&key=value 的字符串
   *
   * @param {Object} paramObj
   * @returns {String}
   */


  function objToParamStr(paramObj) {
    var res = "";
    Object.keys(paramObj).forEach(function (key) {
      if (res == "") {
        res += key + "=" + paramObj[key];
      } else {
        res += "&" + key + "=" + paramObj[key];
      }
    });
    return res;
  } // toast


  function toast(option) {
    var toastCover = document.createElement('div');
    var toastText = document.createElement('div');
    option.duration = option.duration ? option.duration : 3000;
    toastCover.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index:100000; text-align:center;';
    toastCover.id = 'toastCover';
    toastText.style.cssText = 'background:rgba(0, 0, 0, .6); border-radius: 0.10rem; color: #fff; min-width: 40%; max-width: 80%; padding: 0.20rem; font-size: 0.28rem;';
    toastText.id = 'toastText';
    toastText.innerText = option.message;
    toastCover.appendChild(toastText);
    document.body.appendChild(toastCover);
    setTimeout(function () {
      if (document.querySelector('#toastCover')) {
        toastCover.parentNode.removeChild(toastCover);
      }
    }, option.duration);
  }

  var utils = {
    "forEach": forEach,
    "isArray": isArray,
    "trim": trim,
    "isEmpty": isEmpty,
    "deepMerge": deepMerge,
    "extend": extend,
    "objToParamStr": objToParamStr,
    "toast": toast
  };

  function Interceptor() {
    var me = this; // 待执行函数列表

    me.toDoFunctionChain = [];
  } // 添加拦截处理


  Interceptor.prototype.on = function (fulfilled, rejected) {
    var me = this;
    me.toDoFunctionChain.push({
      fulfilled: fulfilled,
      rejected: rejected
    }); // id

    var id = me.toDoFunctionChain.length - 1; // 返回id，可以用来做删除

    return id;
  }; // 删除拦截处理


  Interceptor.prototype.off = function (id) {
    var me = this;

    if (me.toDoFunctionChain[id]) {
      me.toDoFunctionChain[id] = null;
    }
  }; // 循环拦截器，依次执行方法


  Interceptor.prototype.forEach = function forEach(fn) {
    var me = this;
    utils.forEach(me.toDoFunctionChain, function (h) {
      if (h !== null) {
        fn(h);
      }
    });
  };

  function createError(message, config, code, request, response) {
    message = message ? message : "";
    var error = new Error(message);
    error.config = config;
    error.request = request;
    error.response = response;
    utils.isEmpty(code) ? null : error.code = code;
    return error;
  }
  /**
   * 解析请求头或者响应头，将字符串变成对象
   *
   * @param {String} headers
   */


  function parseHeaders(headers) {
    var arr = "";

    if (utils.isArray(headers)) {
      arr = headers;
    } else {
      arr = headers.split(/\r\n/);
    }

    var obj = {};

    for (var i = 0; i < arr.length; i++) {
      var splitIndex = arr[i].indexOf(":"); // key value 分割位置

      var key = utils.trim(arr[i].substr(0, splitIndex)).toLowerCase();
      var val = utils.trim(arr[i].substr(splitIndex + 1));

      if (key) {
        if (key === 'set-cookie') {
          obj[key] = (obj[key] ? obj[key] : []).concat([val]);
        } else {
          obj[key] = obj[key] ? obj[key] + ', ' + val : val;
        }
      }
    }

    return obj;
  }

  function xhrRequest(config) {
    return new Promise(function (resolve, reject) {
      var params = config.params; // url get参数

      var data = config.data; // post 参数

      var request = new XMLHttpRequest();

      if (window.XMLHttpRequest) {
        request = new XMLHttpRequest();
      } else {
        request = new window.ActiveXObject();
      }

      var url = config.baseURL + config.url;

      if (!utils.isEmpty(config.params)) {
        url = url + "?" + utils.objToParamStr(params);
      }

      request.open(config.method, url, config.async); // 请求头设置

      if (!utils.isEmpty(config.headers)) {
        utils.forEach(config.headers, function (header) {
          // request.setRequestHeader(Object.keys(header)[0], Object.values(header)[0]);
          request.setRequestHeader(Object.keys(header)[0], header[Object.keys(header)[0]]);
        });
      }

      request.timeout = config.timeout;

      if (!utils.isEmpty(config.withCredentials)) {
        request.withCredentials = config.withCredentials;
      } // onreadystatechange


      request.onreadystatechange = function () {
        if (!request || request.readyState !== 4) {
          return;
        } // XXX request.status === 0 是什么状态，ajax 有这个，先这样返回，待查资料


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }

        var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
        var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
        var response = {
          data: responseData,
          headers: responseHeaders,
          config: config,
          status: request.status,
          request: request
        };
        resolve(response);
      }; // onabort


      request.onabort = function () {
        if (!request) {
          return;
        }

        reject(createError('Request aborted', config, 'ECONNABORTED', request));
        request = null;
      }; // onerror


      request.onerror = function () {
        reject(createError('Network Error', config, 'ECONNERROR', request));
        request = null;
      }; // ontimeout


      request.ontimeout = function () {
        reject(createError("request timeout", config, 'ECONNTIMEOUT', request));
        request = null;
      };

      if (utils.isEmpty(data)) {
        request.send();
      } else {
        if (typeof data == "string") {
          // x-www-form-urlencoded 等非json结构的，直接发送字符串
          request.send(data);
        } else {
          request.send(JSON.stringify(data));
        }
      }
    });
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var main_min = createCommonjsModule(function (module, exports) {
    !function (e, n) {
      module.exports = n();
    }(commonjsGlobal, function () {
      function n(n, e) {
        var t,
            o = Object.keys(n);
        return Object.getOwnPropertySymbols && (t = Object.getOwnPropertySymbols(n), e && (t = t.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), o.push.apply(o, t)), o;
      }

      function a(o) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? n(Object(r), !0).forEach(function (e) {
            var n, t;
            n = o, e = r[t = e], t in n ? Object.defineProperty(n, t, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : n[t] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function (e) {
            Object.defineProperty(o, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return o;
      }

      var l = {
        str2Json: function str2Json(e) {
          var n = {};
          if ("[object String]" === Object.prototype.toString.call(e)) try {
            n = JSON.parse(e);
          } catch (e) {
            n = {};
          }
          return n;
        },
        json2Str: function json2Str(e) {
          var n = e;
          if ("string" != typeof e) try {
            n = JSON.stringify(e);
          } catch (e) {
            n = "";
          }
          return n;
        },
        cbNum: 0,
        isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
        isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
        isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
        isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
        isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
        isIframePage: window.parent && window.parent != window,
        loadUrl: function loadUrl(e) {
          var n = document.createElement("iframe");
          n.setAttribute("src", e), n.setAttribute("style", "display:none;"), n.setAttribute("height", "0px"), n.setAttribute("width", "0px"), n.setAttribute("frameborder", "0"), document.body.appendChild(n), n.parentNode.removeChild(n), n = null;
        },
        mobileCallInIframe: function mobileCallInIframe(e, n, t) {
          e = {
            type: "KgMobileCall",
            cmd: e
          };
          n && (e.dataJson = n), t && (e.cbName = t), e.source = "personal", window.parent.postMessage(e, "*");
        },
        receiveMessage: function receiveMessage(e) {
          var n = e.data;
          "KgMobileCall" == n.type && window[n.cbName] && (n.dataJson ? window[n.cbName](n.dataJson) : window[n.cbName](), window[n.cbName] = null), "KgWebMobileCall" == n.type && (e = n.funcName.split("."), KgWebMobileCall[e[1]] && (n.dataJson ? KgWebMobileCall[e[1]](n.dataJson) : KgWebMobileCall[e[1]]()));
        },
        callCmd: function callCmd(t) {
          var e,
              n,
              o = l;

          if (o.isKugouAndroid) {
            var r = {},
                a = "";
            t.cmd && (r.cmd = t.cmd), t.jsonStr && (r.jsonStr = t.jsonStr), t.callback && (o.cbNum++, a = "kgandroidmobilecall_" + (t.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), r.callback = a, window[a] = function (e, n) {
              if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                try {
                  e = "#" === n ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                } catch (e) {
                  console.error("decodeURIComponent", e);
                }

                t.callback(o.str2Json(e));
              } else t.callback(e);
            }), t.AndroidCallback && ((c = o.str2Json(t.jsonStr)).AndroidCallback = a, t.jsonStr = o.json2Str(c), t.jsonStr && (r.jsonStr = t.jsonStr));
            var c = encodeURIComponent(JSON.stringify(r)),
                c = "kugoujsbridge://start.kugou_jsbridge/?".concat(c);
            o.isIframePage ? o.mobileCallInIframe(r.cmd, r.jsonStr, a) : o.loadUrl(c);
          } else if (o.isAndroid) {
            var i = "",
                a = "";
            if (t.jsonStr) {
              if (t.callback && "" !== t.callback && !0 === t.AndroidCallback && (o.cbNum++, a = "kgmobilecall_" + (t.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), window[a] = function (e, n) {
                if (void 0 !== e) if ("[object String]" === Object.prototype.toString.call(e)) {
                  try {
                    e = "#" === n ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e));
                  } catch (e) {
                    console.error("decodeURIComponent", decodeURIComponent);
                  }

                  t.callback(o.str2Json(e));
                } else t.callback(e);
              }, (c = o.str2Json(t.jsonStr)).AndroidCallback = a, t.jsonStr = o.json2Str(c)), o.isIframePage && t.AndroidCallback) o.mobileCallInIframe(t.cmd, t.jsonStr, a);else try {
                i = external.superCall(t.cmd, t.jsonStr);
              } catch (e) {}
            } else try {
              i = external.superCall(t.cmd);
            } catch (e) {}
            t.AndroidCallback || t.callback && "" !== t.callback && "AndroidCallback" != i && (i = o.str2Json(i), t.callback(i));
          } else o.isFXAPP || o.isFXQianBanAPP ? (i = n = "", n = t.callback ? (o.cbNum++, i = "kgmobilecall_" + (t.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), window[i] = function (e) {
            void 0 !== e && t.callback && ("[object String]" === Object.prototype.toString.call(e) ? t.callback(o.str2Json(e)) : t.callback(e));
          }, t.jsonStr ? 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + ', "callback":"' + i + '"}' : 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "callback":"' + i + '"}') : t.jsonStr ? 'fanxing2://send.message/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + t.cmd + "}", o.isIframePage ? o.mobileCallInIframe(t.cmd, t.jsonStr, i) : navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/) ? external && external.callFanxing ? (e = {
            cmd: t.cmd,
            jsonStr: t.jsonStr || "",
            callback: i
          }, external.callFanxing(JSON.stringify(e))) : window.prompt(n) : o.loadUrl(n)) : (n = e = "", t.callback && (o.cbNum++, n = "kgmobilecall_" + (t.cmd || 0) + "_" + o.cbNum + Math.random().toString().substr(2, 9), window[n] = function (e) {
            void 0 !== e && t.callback && ("[object String]" === Object.prototype.toString.call(e) ? t.callback(o.str2Json(e)) : t.callback(e));
          }), n && "" != n && t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + ', "callback":"' + n + '"}'), n && "" != n && !t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "callback":"' + n + '"}'), "" == n && t.jsonStr && (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + ', "jsonStr":' + t.jsonStr + "}"), "" != n || t.jsonStr || (e = 'kugouurl://start.music/?{"cmd":' + t.cmd + "}"), o.isIframePage ? o.mobileCallInIframe(t.cmd, t.jsonStr, n) : o.loadUrl(e));
        }
      },
          e = {
        isIOS: l.isIOS,
        isKugouAndroid: l.isKugouAndroid,
        isAndroid: l.isAndroid,
        isFXAPP: l.isFXAPP,
        isFXQianBanAPP: l.isFXQianBanAPP,
        isInClient: function isInClient() {
          return !(!l.isAndroid && !l.isKugouAndroid) || !!l.isIOS || !!l.isFXAPP || !!l.isFXQianBanAPP;
        },
        mobileCall: function mobileCall(e, n, t, o) {
          var r = "";
          if (n && (r = l.json2Str(n)), !e) return console.error("请输入命令号！"), !1;
          n = {};
          e && (n.cmd = e), "" != r && (n.jsonStr = r), t && (n.callback = t), n = a(a({}, n), o), !e || 186 != e && 225 != e || t && (n.AndroidCallback = !0), n.AndroidCallback && !n.jsonStr && (n.jsonStr = {}), l.callCmd(n);
        },
        KgWebMobileCall: function KgWebMobileCall(o, r) {
          if (o) try {
            l.isIframePage && window.parent.postMessage({
              type: "KgWebMobileCall",
              funcName: o
            }, "*");
            var a = o.split(".");
            a.reduce(function (e, n) {
              if (e[n]) {
                if (n !== a[a.length - 1]) return e[n];
                var t = e[n];
                return "function" == typeof t ? (e[n] = function () {
                  t && t.apply(void 0, arguments), r && r.apply(void 0, arguments);
                }, e[n]) : (console.error("请检查，当前环境变量已注册了对象：" + o + "，且该对象不是方法"), null);
              }

              return n === a[a.length - 1] ? e[n] = function () {
                r && r.apply(void 0, arguments);
              } : e[n] = new Object(), e[n];
            }, window);
          } catch (e) {}
        }
      };
      return window.addEventListener("message", function (e) {
        l.receiveMessage(e);
      }, !1), e;
    });
  });

  function mobilecallRequest(config) {
    return new Promise(function (resolve, reject) {
      var params = "";
      var data = config.data ? config.data : "";

      if (!utils.isEmpty(config.params)) {
        params = utils.objToParamStr(config.params);
      }

      var url = config.baseURL + config.url;

      if (!utils.isEmpty(config.params)) {
        url = url + "?" + params;
      }

      var method = config.method;
      var timeout = config.timeout;
      var mobileCallData = {
        url: url,
        method: method,
        timeout: timeout
      };

      if (!utils.isEmpty(data)) {
        // 客户端接收是字符串
        mobileCallData.param = data;

        if (_typeof(data) === "object") {
          mobileCallData.param = JSON.stringify(data);
        }
      }

      if (!utils.isEmpty(config.headers)) {
        mobileCallData.header = {};
        utils.forEach(config.headers, function (header) {
          mobileCallData.header[Object.keys(header)[0]] = header[Object.keys(header)[0]];
        });
      }

      main_min.mobileCall(186, mobileCallData, function (res) {
        var response = {
          data: res.data,
          config: config,
          verify: res.verify || null,
          resHeaders: res.resHeaders || null,
          time: res.time || 0
        };

        if (res && res.status == 1) {
          // 成功
          if (res && res.verify && res.verify.status == 0 && config.kgAntiBushErrFun) {
            if ((main_min.isKugouAndroid || main_min.isAndroid) && res.resHeaders) {
              // 安卓
              if (res.resHeaders["SSA-CODE"] || res.resHeaders["ssa-code"]) {
                // 客户端风控，10分钟内拉起三次，不再拉起风控了，风控处理 (安卓客户端有个坑，可以继续触发风控了，也没有刷新 verify 对象，要继续看 resHeaders 有没有 ssa-code)
                config.kgAntiBushErrFun && config.kgAntiBushErrFun();
                return null;
              }
            } else {
              // iOS
              if (res.resHeaders["SSA-CODE"] || res.resHeaders["ssa-code"]) {
                // 客户端风控，10分钟内拉起三次，不再拉起风控了，风控处理 (客户端有个坑，没有风控的接口，在这10分钟只能也返回了 verify 对象（导致没有办法接收到回调），要继续看 resHeaders 有没有 ssa-code)
                config.kgAntiBushErrFun && config.kgAntiBushErrFun();
                return null;
              }
            }
          }

          resolve(response);
        } else {
          if (res && res.errno && res.errno == 30021 && config.kgAntiBushErrFun) {
            // ios: 10459 版本，有个问题, 没有返回verify对象
            // 客户端风控，10分钟内拉起三次，不再拉起风控了，文案提示
            config.kgAntiBushErrFun && config.kgAntiBushErrFun();
            return null;
          } // 返回命令号的错误


          reject(createError('Request Error: ' + res.errno, config, res.errno, null, null));
        }
      });
    });
  }

  function miniAppRequest(config) {
    return new Promise(function (resolve, reject) {
      var params = "";
      var data = config.data ? config.data : "";

      if (!utils.isEmpty(config.params)) {
        params = utils.objToParamStr(config.params);
      }

      var url = config.baseURL + config.url;

      if (!utils.isEmpty(config.params)) {
        url = url + "?" + params;
      }

      var method = config.method;
      var timeout = config.timeout;
      var mobileCallData = {
        url: url,
        method: method,
        timeout: timeout
      };

      if (!utils.isEmpty(data)) {
        // 客户端接收是字符串
        mobileCallData.data = data;

        if (_typeof(data) === "object") {
          mobileCallData.data = JSON.stringify(data);
        }
      }

      if (!utils.isEmpty(config.headers)) {
        mobileCallData.header = {};
        utils.forEach(config.headers, function (header) {
          mobileCallData.header[Object.keys(header)[0]] = header[Object.keys(header)[0]];
        });
      }

      mobileCallData.dataType = config.dataType || "json";

      mobileCallData.success = function (res) {
        var response = {
          data: res.data,
          statusCode: res.statusCode,
          responseHeader: res.header,
          config: config
        };
        resolve(response);
      };

      mobileCallData.fail = function (res) {
        reject(createError(res.errMsg, config, res.errCode, null, null));
      };

      window.MiniApp && window.MiniApp.request(mobileCallData);
    });
  }

  function dispatchRequest(config) {
    if (config.useMobileCall || config.requestMethod && config.requestMethod == "mobilecall") {
      // 命令号请求
      return mobilecallRequest(config).then(function mobilecallRequestOnFulfilled(response) {
        return response;
      }, function mobilecallRequestOnRejected(res) {
        return Promise.reject(res);
      });
    } else if (config.requestMethod && config.requestMethod == "miniapp") {
      // 小程序
      return miniAppRequest(config).then(function miniAppRequestOnFulfilled(response) {
        return response;
      }, function miniAppRequestOnRejected(res) {
        return Promise.reject(res);
      });
    } else {
      // xhr
      return xhrRequest(config).then(function xhrRequestOnFulfilled(response) {
        return response;
      }, function xhrRequestOnRejected(res) {
        return Promise.reject(res);
      });
    }
  }

  var defaultConfig = {
    url: "",
    // 请求地址（主地址的相对路径）
    baseURL: "",
    // 请求主地址
    retryURL: "",
    // 请求重试地址
    isGateway: true,
    // 是否使用 gateway 请求，缺省默认值： true
    gatewayURL: "",
    retry: 1,
    // 默认重试 1 次
    timeout: 5000,
    // 设置超时时间，缺省默认值 5000
    params: null,
    data: null,
    method: "get",
    async: true,
    // 同步或异步请求
    useMobileCall: false,
    kgAntiBushUrl: window.location.href,
    isAllowKGAntiBush: true,
    kgAntiBushURL: "",
    kgAntiBushAppid: "",
    kgAntiBushMid: "",
    kgAntiBushUserid: "",
    sign: "",
    signSalt: "",
    isAllowSign: true
  };
  /**
   * 合并配置对象
   *
   * @param {Object} globalConfig 用户设置的全局配置对象
   * @param {Object} paramsConfig 调用 request 方法，参数传进来的配置对象
   * 
   * @return {Object} config 合并之后的配置对象
   */

  function handleConfig(globalConfig, paramsConfig) {
    paramsConfig = paramsConfig || {};
    var config = {}; // 优先级 paramsConfig > defaultConfig

    config = utils.deepMerge(defaultConfig, paramsConfig);
    /** 
     * ===============================
     * 请求头
     * ===============================
     */

    config.headers = config.headers ? config.headers : [];
    /** 
     * ===============================
     * 容灾、getway相关
     * 处理跟容灾、gateway 相关的配置参数
     * ===============================
     */
    // url

    config.url = utils.trim(config.url);

    if (!utils.isEmpty(config.url) && config.url.indexOf("/") != 0) {
      // url 第一个字符不是 /
      config.url = "/" + config.url;
    } // baseUrl


    config.baseURL = utils.trim(config.baseURL);

    if (!utils.isEmpty(config.baseURL) && config.baseURL.charAt(config.baseURL.length - 1) === "/") {
      // 去掉 baseUrl 传进来的最后的 /
      config.baseURL = config.baseURL.substring(0, config.baseURL.length - 1);
    } // gatewayURL


    config.gatewayURL = utils.trim(config.gatewayURL);

    if (!utils.isEmpty(config.gatewayURL) && config.gatewayURL.charAt(config.gatewayURL.length - 1) === "/") {
      // 去掉 gatewayURL 传进来的最后的 /
      config.gatewayURL = config.gatewayURL.substring(0, config.gatewayURL.length - 1);
    } // retryURL


    config.retryURL = utils.trim(config.retryURL);

    if (utils.isEmpty(config.retryURL)) {
      config.retryURL = config.baseURL;
    }

    if (!utils.isEmpty(config.retryURL) && config.retryURL.charAt(config.retryURL.length - 1) === "/") {
      // 去掉 retryURL 传进来的最后的 /
      config.retryURL = config.retryURL.substring(0, config.retryURL.length - 1);
    } // isGateway


    config.isGateway = config.isGateway === true ? true : false; // 如果用 gateway 请求，缺省默认值用 baseURL 

    config.gatewayURL = config.gatewayURL ? config.gatewayURL : config.baseURL;

    if (config.isGateway && utils.isEmpty(config.gatewayURL)) {
      console.error("如果要使用 gateway 请求，请传入正确的 gatewayURL 或者 baseURL");
      return null;
    } // 处理 gateway 的请求头参数


    if (config.isGateway && !utils.isEmpty(config.gatewayURL)) {
      // gateway 规则，请求头 x-router 只要域名就行了，去掉协议
      var gatewayUrl = config.gatewayURL.replace(/https:\/\/|http:\/\//ig, "");
      var tempHeaders = new Array();
      utils.forEach(config.headers, function (header) {
        if ("x-router" in header) ;else {
          tempHeaders.push(header);
        }
      });
      config.headers = tempHeaders;
      var gateRouter = gatewayUrl.replace(".kugou.com", ""); // 改成用 gateway 2.0  http://doc.kugou.net/showdoc-master/web/#/6?page_id=7300

      config.baseURL = "https://gateway.kugou.com/".concat(gateRouter);
      config.retryURL = "https://gatewayretry.kugou.com/".concat(gateRouter);
    } // timeout 超时，默认 5000ms


    config.timeout = config.timeout ? config.timeout : 5000; // retry 重试次数设置

    config.retry = config.retry;
    /** 
     * ===============================
     * 参数相关
     * params URLSearchParams，即将与请求一起发送的 URL 参数
     * data 请求主体被发送的数据，body
     * ===============================
     */

    config.data = config.data ? config.data : "";

    if (JSON.stringify(config.data) == "{}") {
      config.data = null;
    }
    /** 
     * ===============================
     * 请求方式
     * ===============================
     */
    // method


    config.method = config.method ? config.method : "get";
    config.method = config.method.toLowerCase(); // async

    config.async = config.async === true ? true : false; // useMobileCall

    config.useMobileCall = config.useMobileCall === true ? true : false;

    if (!utils.isEmpty(config.withCredentials)) {
      config.withCredentials = config.withCredentials === true ? true : false;
    }
    /** 
     * ===============================
     * 风控相关
     * ===============================
     */


    config.isAllowKGAntiBush = config.isAllowKGAntiBush === true ? true : false;

    if (config.isAllowKGAntiBush) {
      config.kgAntiBushURL = config.kgAntiBushURL ? config.kgAntiBushURL : window.location.href;
      config.kgAntiBushAppid = config.kgAntiBushAppid ? config.kgAntiBushAppid : config.params.appid ? config.params.appid : "";
      config.kgAntiBushMid = config.kgAntiBushMid ? config.kgAntiBushMid : config.params.mid ? config.params.mid : "";
      config.kgAntiBushUserid = config.kgAntiBushUserid ? config.kgAntiBushUserid : config.params.userid ? config.params.userid : 0;

      if (utils.isEmpty(config.kgAntiBushAppid)) {
        console.error("使用了isAllowKGAntiBush=true，但是没有传appid");
        return null;
      }

      if (utils.isEmpty(config.kgAntiBushMid)) {
        console.error("使用了isAllowKGAntiBush=true，但是没有传mid");
        return null;
      }
    }

    if (config && config.useMobileCall) {
      config.kgAntiBushErrFun = config.kgAntiBushErrFun || function () {
        utils.toast({
          message: "操作过于频繁，请稍后再试",
          duration: "2000"
        });
      };
    }

    return config;
  }
  /**
   * new KfcRequest instance
   *
   * @param {*} requestConfig 配置对象
   */


  function KFCRequest(requestConfig) {
    var me = this;
    me.requestConfig = requestConfig;
    me.interceptors = {
      request: new Interceptor(),
      response: new Interceptor()
    };
  }

  KFCRequest.prototype.request = function request(config) {
    var me = this;
    config = handleConfig(me.requestConfig, config);
    var promise = Promise.resolve(config); // 等待执行的方法

    var toDoFunctionChain = new Array(); // 循环添加 interceptors.request，数组头部添加

    me.interceptors.request.forEach(function (interceptor) {
      toDoFunctionChain.unshift(interceptor.fulfilled, interceptor.rejected);
    }); // 添加 dispatchRequest，放在 interceptors.request 后面

    toDoFunctionChain.push(dispatchRequest, undefined); // 循环添加 interceptors.response，数组尾部添加

    me.interceptors.response.forEach(function (interceptor) {
      toDoFunctionChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    while (toDoFunctionChain.length) {
      promise = promise.then(toDoFunctionChain.shift(), toDoFunctionChain.shift());
    }

    return promise;
  };

  var md5 = createCommonjsModule(function (module) {
    (function ($) {
      /**
       * Add integers, wrapping at 2^32.
       * This uses 16-bit operations internally to work around bugs in interpreters.
       *
       * @param {number} x First integer
       * @param {number} y Second integer
       * @returns {number} Sum
       */
      function safeAdd(x, y) {
        var lsw = (x & 0xffff) + (y & 0xffff);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xffff;
      }
      /**
       * Bitwise rotate a 32-bit number to the left.
       *
       * @param {number} num 32-bit number
       * @param {number} cnt Rotation count
       * @returns {number} Rotated number
       */


      function bitRotateLeft(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
      }
      /**
       * Basic operation the algorithm uses.
       *
       * @param {number} q q
       * @param {number} a a
       * @param {number} b b
       * @param {number} x x
       * @param {number} s s
       * @param {number} t t
       * @returns {number} Result
       */


      function md5cmn(q, a, b, x, s, t) {
        return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
      }
      /**
       * Basic operation the algorithm uses.
       *
       * @param {number} a a
       * @param {number} b b
       * @param {number} c c
       * @param {number} d d
       * @param {number} x x
       * @param {number} s s
       * @param {number} t t
       * @returns {number} Result
       */


      function md5ff(a, b, c, d, x, s, t) {
        return md5cmn(b & c | ~b & d, a, b, x, s, t);
      }
      /**
       * Basic operation the algorithm uses.
       *
       * @param {number} a a
       * @param {number} b b
       * @param {number} c c
       * @param {number} d d
       * @param {number} x x
       * @param {number} s s
       * @param {number} t t
       * @returns {number} Result
       */


      function md5gg(a, b, c, d, x, s, t) {
        return md5cmn(b & d | c & ~d, a, b, x, s, t);
      }
      /**
       * Basic operation the algorithm uses.
       *
       * @param {number} a a
       * @param {number} b b
       * @param {number} c c
       * @param {number} d d
       * @param {number} x x
       * @param {number} s s
       * @param {number} t t
       * @returns {number} Result
       */


      function md5hh(a, b, c, d, x, s, t) {
        return md5cmn(b ^ c ^ d, a, b, x, s, t);
      }
      /**
       * Basic operation the algorithm uses.
       *
       * @param {number} a a
       * @param {number} b b
       * @param {number} c c
       * @param {number} d d
       * @param {number} x x
       * @param {number} s s
       * @param {number} t t
       * @returns {number} Result
       */


      function md5ii(a, b, c, d, x, s, t) {
        return md5cmn(c ^ (b | ~d), a, b, x, s, t);
      }
      /**
       * Calculate the MD5 of an array of little-endian words, and a bit length.
       *
       * @param {Array} x Array of little-endian words
       * @param {number} len Bit length
       * @returns {Array<number>} MD5 Array
       */


      function binlMD5(x, len) {
        /* append padding */
        x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i;
        var olda;
        var oldb;
        var oldc;
        var oldd;
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;

        for (i = 0; i < x.length; i += 16) {
          olda = a;
          oldb = b;
          oldc = c;
          oldd = d;
          a = md5ff(a, b, c, d, x[i], 7, -680876936);
          d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
          c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
          b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
          a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
          d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
          c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
          b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
          a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
          d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
          c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
          b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
          a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
          d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
          c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
          b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
          a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
          d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
          c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
          b = md5gg(b, c, d, a, x[i], 20, -373897302);
          a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
          d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
          c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
          b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
          a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
          d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
          c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
          b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
          a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
          d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
          c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
          b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
          a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
          d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
          c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
          b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
          a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
          d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
          c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
          b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
          a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
          d = md5hh(d, a, b, c, x[i], 11, -358537222);
          c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
          b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
          a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
          d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
          c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
          b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
          a = md5ii(a, b, c, d, x[i], 6, -198630844);
          d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
          c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
          b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
          a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
          d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
          c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
          b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
          a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
          d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
          c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
          b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
          a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
          d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
          c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
          b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
          a = safeAdd(a, olda);
          b = safeAdd(b, oldb);
          c = safeAdd(c, oldc);
          d = safeAdd(d, oldd);
        }

        return [a, b, c, d];
      }
      /**
       * Convert an array of little-endian words to a string
       *
       * @param {Array<number>} input MD5 Array
       * @returns {string} MD5 string
       */


      function binl2rstr(input) {
        var i;
        var output = '';
        var length32 = input.length * 32;

        for (i = 0; i < length32; i += 8) {
          output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
        }

        return output;
      }
      /**
       * Convert a raw string to an array of little-endian words
       * Characters >255 have their high-byte silently ignored.
       *
       * @param {string} input Raw input string
       * @returns {Array<number>} Array of little-endian words
       */


      function rstr2binl(input) {
        var i;
        var output = [];
        output[(input.length >> 2) - 1] = undefined;

        for (i = 0; i < output.length; i += 1) {
          output[i] = 0;
        }

        var length8 = input.length * 8;

        for (i = 0; i < length8; i += 8) {
          output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
        }

        return output;
      }
      /**
       * Calculate the MD5 of a raw string
       *
       * @param {string} s Input string
       * @returns {string} Raw MD5 string
       */


      function rstrMD5(s) {
        return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
      }
      /**
       * Calculates the HMAC-MD5 of a key and some data (raw strings)
       *
       * @param {string} key HMAC key
       * @param {string} data Raw input string
       * @returns {string} Raw MD5 string
       */


      function rstrHMACMD5(key, data) {
        var i;
        var bkey = rstr2binl(key);
        var ipad = [];
        var opad = [];
        var hash;
        ipad[15] = opad[15] = undefined;

        if (bkey.length > 16) {
          bkey = binlMD5(bkey, key.length * 8);
        }

        for (i = 0; i < 16; i += 1) {
          ipad[i] = bkey[i] ^ 0x36363636;
          opad[i] = bkey[i] ^ 0x5c5c5c5c;
        }

        hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
      }
      /**
       * Convert a raw string to a hex string
       *
       * @param {string} input Raw input string
       * @returns {string} Hex encoded string
       */


      function rstr2hex(input) {
        var hexTab = '0123456789abcdef';
        var output = '';
        var x;
        var i;

        for (i = 0; i < input.length; i += 1) {
          x = input.charCodeAt(i);
          output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
        }

        return output;
      }
      /**
       * Encode a string as UTF-8
       *
       * @param {string} input Input string
       * @returns {string} UTF8 string
       */


      function str2rstrUTF8(input) {
        return unescape(encodeURIComponent(input));
      }
      /**
       * Encodes input string as raw MD5 string
       *
       * @param {string} s Input string
       * @returns {string} Raw MD5 string
       */


      function rawMD5(s) {
        return rstrMD5(str2rstrUTF8(s));
      }
      /**
       * Encodes input string as Hex encoded string
       *
       * @param {string} s Input string
       * @returns {string} Hex encoded string
       */


      function hexMD5(s) {
        return rstr2hex(rawMD5(s));
      }
      /**
       * Calculates the raw HMAC-MD5 for the given key and data
       *
       * @param {string} k HMAC key
       * @param {string} d Input string
       * @returns {string} Raw MD5 string
       */


      function rawHMACMD5(k, d) {
        return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
      }
      /**
       * Calculates the Hex encoded HMAC-MD5 for the given key and data
       *
       * @param {string} k HMAC key
       * @param {string} d Input string
       * @returns {string} Raw MD5 string
       */


      function hexHMACMD5(k, d) {
        return rstr2hex(rawHMACMD5(k, d));
      }
      /**
       * Calculates MD5 value for a given string.
       * If a key is provided, calculates the HMAC-MD5 value.
       * Returns a Hex encoded string unless the raw argument is given.
       *
       * @param {string} string Input string
       * @param {string} [key] HMAC key
       * @param {boolean} [raw] Raw output switch
       * @returns {string} MD5 output
       */


      function md5(string, key, raw) {
        if (!key) {
          if (!raw) {
            return hexMD5(string);
          }

          return rawMD5(string);
        }

        if (!raw) {
          return hexHMACMD5(key, string);
        }

        return rawHMACMD5(key, string);
      }

      if (module.exports) {
        module.exports = md5;
      } else {
        $.md5 = md5;
      }
    })(commonjsGlobal);
  });
  var main_min$1 = createCommonjsModule(function (module, exports) {
    !function (e, n) {
      module.exports = n();
    }(commonjsGlobal, function () {
      var e = {
        Cookie: {
          write: function write(e, n, t, i, r, o) {
            /^\w*$/.test(e) || alert("cookie格式不正确"), /; /.test(n) && alert("cookie格式不正确");
            var a = e + "=" + n;

            if (t) {
              var l = new Date();
              l.setTime(l.getTime() + 1e3 * t), a += "; expires=" + l.toGMTString();
            }

            i && (a += "; path=" + i), r && (a += "; domain=" + r), o && (a += "; secure"), document.cookie = a;
          },
          rewriteKey: function rewriteKey(e, n, t, i, r, o, a) {
            var l = n;

            if (t) {
              var s = this.read(e),
                  c = new RegExp("\\b" + n + "=([^&]*)\\b", "g");
              l = s.replace(c, function (e, n) {
                return e.replace(n, t);
              });
            }

            /^\d+(s|m|h|d)$/i.test(i) ? (/^\d+s$/i.test(i) && this.setSec(e, l, i.replace(/s$/i, ""), r, o, a), /^\d+m$/i.test(i) && this.setMin(e, l, i.replace(/m$/i, ""), r, o, a), /^\d+h$/i.test(i) && this.setHour(e, l, i.replace(/h$/i, ""), r, o, a), /^\d+d$/i.test(i) && this.setDay(e, l, i.replace(/d$/i, ""), r, o, a)) : this.write(e, l, i, r, o, a);
          },
          setDay: function setDay(e, n, t, i, r, o) {
            this.write(e, n, 24 * t * 60 * 60, i, r, o);
          },
          setHour: function setHour(e, n, t, i, r, o) {
            this.write(e, n, 60 * t * 60, i, r, o);
          },
          setMin: function setMin(e, n, t, i, r, o) {
            this.write(e, n, 60 * t, i, r, o);
          },
          setSec: function setSec(e, n, t, i, r, o) {
            this.write(e, n, t, i, r, o);
          },
          read: function read(n, t, i) {
            for (var r = "", o = document.cookie.split("; "), a = 0; a < o.length; a++) {
              var l = o[a].match(/^(\w+)=(.+)$/);

              if (l && l.length > 1 && l[1] == n) {
                r = l[2];
                break;
              }
            }

            return "" == r ? null : t ? i ? JSON.parse(r)[t] : new e.Param().parse(r)[t] : r;
          },
          remove: function remove(e, n, t) {
            var i = e + "=";
            n && (i += "; path=" + n), t && (i += ";domain=" + t), i += "; expires=Fri, 02-Jan-1970 00:00:00 GMT", document.cookie = i;
          }
        },
        Md5: function Md5(e) {
          function n(e, n) {
            e[n >> 5] |= 128 << n % 32, e[14 + (n + 64 >>> 9 << 4)] = n;

            for (var t = 1732584193, s = -271733879, c = -1732584194, u = 271733878, d = 0; d < e.length; d += 16) {
              var f = t,
                  m = s,
                  g = c,
                  p = u;
              s = a(s = a(s = a(s = a(s = o(s = o(s = o(s = o(s = r(s = r(s = r(s = r(s = i(s = i(s = i(s = i(s, c = i(c, u = i(u, t = i(t, s, c, u, e[d + 0], 7, -680876936), s, c, e[d + 1], 12, -389564586), t, s, e[d + 2], 17, 606105819), u, t, e[d + 3], 22, -1044525330), c = i(c, u = i(u, t = i(t, s, c, u, e[d + 4], 7, -176418897), s, c, e[d + 5], 12, 1200080426), t, s, e[d + 6], 17, -1473231341), u, t, e[d + 7], 22, -45705983), c = i(c, u = i(u, t = i(t, s, c, u, e[d + 8], 7, 1770035416), s, c, e[d + 9], 12, -1958414417), t, s, e[d + 10], 17, -42063), u, t, e[d + 11], 22, -1990404162), c = i(c, u = i(u, t = i(t, s, c, u, e[d + 12], 7, 1804603682), s, c, e[d + 13], 12, -40341101), t, s, e[d + 14], 17, -1502002290), u, t, e[d + 15], 22, 1236535329), c = r(c, u = r(u, t = r(t, s, c, u, e[d + 1], 5, -165796510), s, c, e[d + 6], 9, -1069501632), t, s, e[d + 11], 14, 643717713), u, t, e[d + 0], 20, -373897302), c = r(c, u = r(u, t = r(t, s, c, u, e[d + 5], 5, -701558691), s, c, e[d + 10], 9, 38016083), t, s, e[d + 15], 14, -660478335), u, t, e[d + 4], 20, -405537848), c = r(c, u = r(u, t = r(t, s, c, u, e[d + 9], 5, 568446438), s, c, e[d + 14], 9, -1019803690), t, s, e[d + 3], 14, -187363961), u, t, e[d + 8], 20, 1163531501), c = r(c, u = r(u, t = r(t, s, c, u, e[d + 13], 5, -1444681467), s, c, e[d + 2], 9, -51403784), t, s, e[d + 7], 14, 1735328473), u, t, e[d + 12], 20, -1926607734), c = o(c, u = o(u, t = o(t, s, c, u, e[d + 5], 4, -378558), s, c, e[d + 8], 11, -2022574463), t, s, e[d + 11], 16, 1839030562), u, t, e[d + 14], 23, -35309556), c = o(c, u = o(u, t = o(t, s, c, u, e[d + 1], 4, -1530992060), s, c, e[d + 4], 11, 1272893353), t, s, e[d + 7], 16, -155497632), u, t, e[d + 10], 23, -1094730640), c = o(c, u = o(u, t = o(t, s, c, u, e[d + 13], 4, 681279174), s, c, e[d + 0], 11, -358537222), t, s, e[d + 3], 16, -722521979), u, t, e[d + 6], 23, 76029189), c = o(c, u = o(u, t = o(t, s, c, u, e[d + 9], 4, -640364487), s, c, e[d + 12], 11, -421815835), t, s, e[d + 15], 16, 530742520), u, t, e[d + 2], 23, -995338651), c = a(c, u = a(u, t = a(t, s, c, u, e[d + 0], 6, -198630844), s, c, e[d + 7], 10, 1126891415), t, s, e[d + 14], 15, -1416354905), u, t, e[d + 5], 21, -57434055), c = a(c, u = a(u, t = a(t, s, c, u, e[d + 12], 6, 1700485571), s, c, e[d + 3], 10, -1894986606), t, s, e[d + 10], 15, -1051523), u, t, e[d + 1], 21, -2054922799), c = a(c, u = a(u, t = a(t, s, c, u, e[d + 8], 6, 1873313359), s, c, e[d + 15], 10, -30611744), t, s, e[d + 6], 15, -1560198380), u, t, e[d + 13], 21, 1309151649), c = a(c, u = a(u, t = a(t, s, c, u, e[d + 4], 6, -145523070), s, c, e[d + 11], 10, -1120210379), t, s, e[d + 2], 15, 718787259), u, t, e[d + 9], 21, -343485551), t = l(t, f), s = l(s, m), c = l(c, g), u = l(u, p);
            }

            return Array(t, s, c, u);
          }

          function t(e, n, t, i, r, o) {
            return l(s(l(l(n, e), l(i, o)), r), t);
          }

          function i(e, n, i, r, o, a, l) {
            return t(n & i | ~n & r, e, n, o, a, l);
          }

          function r(e, n, i, r, o, a, l) {
            return t(n & r | i & ~r, e, n, o, a, l);
          }

          function o(e, n, i, r, o, a, l) {
            return t(n ^ i ^ r, e, n, o, a, l);
          }

          function a(e, n, i, r, o, a, l) {
            return t(i ^ (n | ~r), e, n, o, a, l);
          }

          function l(e, n) {
            var t = (65535 & e) + (65535 & n);
            return (e >> 16) + (n >> 16) + (t >> 16) << 16 | 65535 & t;
          }

          function s(e, n) {
            return e << n | e >>> 32 - n;
          }

          function c(e) {
            for (var n = Array(), t = (1 << d) - 1, i = 0; i < e.length * d; i += d) {
              n[i >> 5] |= (e.charCodeAt(i / d) & t) << i % 32;
            }

            return n;
          }

          function u(e) {
            for (var n = "", t = 0; t < 4 * e.length; t++) {
              n += "0123456789abcdef".charAt(e[t >> 2] >> t % 4 * 8 + 4 & 15) + "0123456789abcdef".charAt(e[t >> 2] >> t % 4 * 8 & 15);
            }

            return n;
          }

          var d = 8;
          return e = e ? function (e) {
            return u(n(c(e), e.length * d));
          }(e) : "";
        },
        Param: function Param() {
          var e = [],
              n = {};
          this.parse = function (e) {
            for (var t = e.split("&"), i = 0, r = t.length; i < r; i++) {
              var o = t[i].split("=");
              n[o[0]] = o[1];
            }

            return n;
          }, this.toString = function (n) {
            return n = n || "&", e.join(n);
          }, this.add = function (n, t) {
            var i = n + "=" + t;
            return e.push(i), this;
          };
        },
        IsEmpty: function IsEmpty(e) {
          return void 0 === e || null == e || "" == e;
        },
        Guid: function Guid() {
          function e() {
            return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
          }

          return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
        },
        getKgMid: function getKgMid() {
          var n = e.Cookie.read("kg_mid");

          if (navigator.cookieEnabled) {
            if (e.IsEmpty(n)) {
              var t = e.Guid();
              n = e.Md5(t);

              try {
                e.Cookie.write("kg_mid", e.Md5(t), 864e6, "/", "kugou.com");
              } catch (e) {}
            }
          } else {
            var i = navigator.userAgent,
                r = function () {
              var e = navigator.plugins,
                  n = "";

              if (e.length > 0) {
                for (var t = [], i = 0, r = e.length; i < r; i++) {
                  var o = e[i].name;
                  t.push(o);
                }

                n = t.toString();
              }

              return n;
            }(),
                o = screen.width + "x" + screen.height,
                a = screen.colorDepth ? screen.colorDepth : "",
                l = screen.pixelDepth ? screen.pixelDepth : "",
                s = function () {
              var n = ["canvas"];

              try {
                var t = document.createElement("canvas");

                if (t.getContext && t.getContext("2d")) {
                  t.width = 200, t.height = 200, t.style.display = "inline";
                  var i = t.getContext("2d");
                  i.rect(0, 0, 10, 10), i.rect(2, 2, 6, 6), n.push("canvas winding:" + (!1 === i.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), i.textBaseline = "alphabetic", i.fillStyle = "#f60", i.fillRect(125, 1, 62, 20), i.fillStyle = "#069", i.font = "14px 'Arial'", i.fillText("hello kugou", 2, 15), i.fillStyle = "rgba(102, 204, 0, 0.2)", i.font = "18pt Arial", i.fillText("hello kugou", 4, 45), i.globalCompositeOperation = "multiply", i.fillStyle = "rgb(255,0,255)", i.beginPath(), i.arc(50, 50, 50, 0, 2 * Math.PI, !0), i.closePath(), i.fill(), i.fillStyle = "rgb(0,255,255)", i.beginPath(), i.arc(100, 50, 50, 0, 2 * Math.PI, !0), i.closePath(), i.fill(), i.fillStyle = "rgb(255,255,0)", i.beginPath(), i.arc(75, 100, 50, 0, 2 * Math.PI, !0), i.closePath(), i.fill(), i.fillStyle = "rgb(255,0,255)", i.arc(75, 75, 75, 0, 2 * Math.PI, !0), i.arc(75, 75, 25, 0, 2 * Math.PI, !0), i.fill("evenodd"), t.toDataURL && n.push("canvas fp:" + t.toDataURL());
                }
              } catch (e) {}

              return e.Md5(n.toString());
            }();

            n = e.Md5(i + r + o + a + l + s);
          }

          return n;
        },
        isiOS: function isiOS() {
          var e = navigator.userAgent,
              n = e.match(/(iPad).*OS\s([\d_]+)/),
              t = e.match(/(iPod)(.*OS\s([\d_]+))?/),
              i = !n && e.match(/(iPhone\sOS)\s([\d_]+)/);
          return !!(n || t || i);
        }
      },
          n = function (e, n) {
        return n = {
          exports: {}
        }, e(n, n.exports), n.exports;
      }(function (e, n) {
        !function (n, t) {
          e.exports = function () {
            var e = {
              str2Json: function str2Json(e) {
                var n = {};
                if ("[object String]" === Object.prototype.toString.call(e)) try {
                  n = JSON.parse(e);
                } catch (e) {
                  n = {};
                }
                return n;
              },
              json2Str: function json2Str(e) {
                var n = e;
                if ("string" != typeof e) try {
                  n = JSON.stringify(e);
                } catch (e) {
                  n = "";
                }
                return n;
              },
              cbNum: 0,
              isIOS: !!navigator.userAgent.match(/KGBrowser/gi),
              isKugouAndroid: !!navigator.userAgent.match(/kugouandroid/gi),
              isAndroid: "undefined" != typeof external && void 0 !== external.superCall,
              isFXAPP: !!navigator.userAgent.match(/Fanxing/gi),
              isFXQianBanAPP: !!navigator.userAgent.match(/QianBan/gi),
              isIframePage: window.parent && window.parent != window,
              loadUrl: function loadUrl(e) {
                var n = document.createElement("iframe");
                n.setAttribute("src", e), n.setAttribute("style", "display:none;"), n.setAttribute("height", "0px"), n.setAttribute("width", "0px"), n.setAttribute("frameborder", "0"), document.body.appendChild(n), n.parentNode.removeChild(n), n = null;
              },
              mobileCallInIframe: function mobileCallInIframe(e, n, t) {
                var i = {
                  type: "KgMobileCall",
                  cmd: e
                };
                n && (i.dataJson = n), t && (i.cbName = t), i.source = "personal", window.parent.postMessage(i, "*");
              },
              receiveMessage: function receiveMessage(e) {
                var n = e.data;

                if ("KgMobileCall" == n.type && window[n.cbName] && (n.dataJson ? window[n.cbName](n.dataJson) : window[n.cbName](), window[n.cbName] = null), "KgWebMobileCall" == n.type) {
                  var t = n.funcName.split(".");
                  KgWebMobileCall[t[1]] && (n.dataJson ? KgWebMobileCall[t[1]](n.dataJson) : KgWebMobileCall[t[1]]());
                }
              },
              callCmd: function callCmd(n) {
                var t = e;

                if (t.isKugouAndroid) {
                  var i = {},
                      r = "";

                  if (n.cmd && (i.cmd = n.cmd), n.jsonStr && (i.jsonStr = n.jsonStr), n.callback && (t.cbNum++, r = "kgandroidmobilecall_" + (n.cmd || 0) + "_" + t.cbNum + Math.random().toString().substr(2, 9), i.callback = r, window[r] = function (e, i) {
                    void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === i ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(t.str2Json(e))) : n.callback(e));
                  }), n.AndroidCallback) {
                    var o = t.str2Json(n.jsonStr);
                    o.AndroidCallback = r, n.jsonStr = t.json2Str(o), n.jsonStr && (i.jsonStr = n.jsonStr);
                  }

                  var a = encodeURIComponent(JSON.stringify(i)),
                      l = "kugoujsbridge://start.kugou_jsbridge/?".concat(a);
                  t.isIframePage ? t.mobileCallInIframe(i.cmd, i.jsonStr, r) : t.loadUrl(l);
                } else if (t.isAndroid) {
                  var s = "",
                      c = "";

                  if (n.jsonStr) {
                    if (n.callback && "" !== n.callback && !0 === n.AndroidCallback) {
                      t.cbNum++, c = "kgmobilecall_" + (n.cmd || 0) + "_" + t.cbNum + Math.random().toString().substr(2, 9), window[c] = function (e, i) {
                        void 0 !== e && ("[object String]" === Object.prototype.toString.call(e) ? (e = "#" === i ? decodeURIComponent(e) : decodeURIComponent(decodeURIComponent(e)), n.callback(t.str2Json(e))) : n.callback(e));
                      };
                      var u = t.str2Json(n.jsonStr);
                      u.AndroidCallback = c, n.jsonStr = t.json2Str(u);
                    }

                    if (t.isIframePage && n.AndroidCallback) t.mobileCallInIframe(n.cmd, n.jsonStr, c);else try {
                      s = external.superCall(n.cmd, n.jsonStr);
                    } catch (e) {}
                  } else try {
                    s = external.superCall(n.cmd);
                  } catch (e) {}

                  (!t.isIframePage || t.isIframePage && !n.AndroidCallback) && n.callback && "" !== n.callback && "AndroidCallback" != s && (s = t.str2Json(s), n.callback(s));
                } else if (t.isFXAPP || t.isFXQianBanAPP) {
                  var d = "",
                      f = "";
                  if (n.callback ? (t.cbNum++, f = "kgmobilecall_" + (n.cmd || 0) + "_" + t.cbNum + Math.random().toString().substr(2, 9), window[f] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(t.str2Json(e)) : n.callback(e));
                  }, d = n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + f + '"}' : 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "callback":"' + f + '"}') : d = n.jsonStr ? 'fanxing2://send.message/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}" : 'fanxing2://send.message/?{"cmd":' + n.cmd + "}", t.isIframePage) t.mobileCallInIframe(n.cmd, n.jsonStr, f);else if (navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/)) {
                    if (external && external.callFanxing) {
                      var m = {
                        cmd: n.cmd,
                        jsonStr: n.jsonStr || "",
                        callback: f
                      };
                      external.callFanxing(JSON.stringify(m));
                    } else window.prompt(d);
                  } else t.loadUrl(d);
                } else {
                  var g = "",
                      p = "";
                  n.callback && (t.cbNum++, p = "kgmobilecall_" + (n.cmd || 0) + "_" + t.cbNum + Math.random().toString().substr(2, 9), window[p] = function (e) {
                    void 0 !== e && n.callback && ("[object String]" === Object.prototype.toString.call(e) ? n.callback(t.str2Json(e)) : n.callback(e));
                  }), p && "" != p && n.jsonStr && (g = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + ', "callback":"' + p + '"}'), p && "" != p && !n.jsonStr && (g = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "callback":"' + p + '"}'), "" == p && n.jsonStr && (g = 'kugouurl://start.music/?{"cmd":' + n.cmd + ', "jsonStr":' + n.jsonStr + "}"), "" != p || n.jsonStr || (g = 'kugouurl://start.music/?{"cmd":' + n.cmd + "}"), t.isIframePage ? t.mobileCallInIframe(n.cmd, n.jsonStr, p) : t.loadUrl(g);
                }
              }
            },
                n = {
              isIOS: e.isIOS,
              isKugouAndroid: e.isKugouAndroid,
              isAndroid: e.isAndroid,
              isFXAPP: e.isFXAPP,
              isFXQianBanAPP: e.isFXQianBanAPP,
              isInClient: function isInClient() {
                return !!(e.isAndroid || e.isKugouAndroid || e.isIOS || e.isFXAPP || e.isFXQianBanAPP);
              },
              mobileCall: function mobileCall(n, t, i) {
                var r = "";
                if (t && (r = e.json2Str(t)), !n) return console.error("请输入命令号！"), !1;
                var o = {};
                n && (o.cmd = n), "" != r && (o.jsonStr = r), i && (o.callback = i), !n || 186 != n && 225 != n || i && (o.AndroidCallback = !0), e.callCmd(o);
              },
              KgWebMobileCall: function KgWebMobileCall(n, t) {
                if (n) try {
                  e.isIframePage && window.parent.postMessage({
                    type: "KgWebMobileCall",
                    funcName: n
                  }, "*");
                  var i = n.split(".");
                  i.reduce(function (e, r) {
                    if (e[r]) {
                      if (r === i[i.length - 1]) {
                        var o = e[r];
                        return "function" == typeof o ? (e[r] = function () {
                          o && o.apply(void 0, arguments), t && t.apply(void 0, arguments);
                        }, e[r]) : (console.error("请检查，当前环境变量已注册了对象：" + n + "，且该对象不是方法"), null);
                      }

                      return e[r];
                    }

                    return r === i[i.length - 1] ? e[r] = function () {
                      t && t.apply(void 0, arguments);
                    } : e[r] = new Object(), e[r];
                  }, window);
                } catch (e) {}
              }
            };
            return window.addEventListener("message", function (n) {
              e.receiveMessage(n);
            }, !1), n;
          }();
        }();
      });

      return function (t, i) {
        var r = {
          getUserInfo: 101,
          getVersion: 122,
          getMobileInfo: 124
        },
            o = {
          appid: null,
          mid: null,
          uuid: null,
          plat: null,
          dfid: null,
          userid: null,
          userpic: null,
          userNickName: null,
          token: null,
          clientver: null
        };
        if (n.isInClient() && !n.isFXAP) n.mobileCall(r.getUserInfo, null, function (e) {
          1 == e.status ? (o.userid = e.kugouID, o.token = e.token, o.userpic = e.photo, o.userNickName = e.nickName, o.isVIP = e.isVIP || e.isVip) : (o.userid = null, o.token = null, o.userpic = null, o.userNickName = null), o.appid = e.appid, n.mobileCall(r.getVersion, null, function (e) {
            o.clientver = e.version, n.mobileCall(r.getMobileInfo, null, function (e) {
              o.mid = e.mid_v2 ? e.mid_v2 : e.mid, o.dfid = e.dfid ? e.dfid : "-", o.uuid = e.uuid ? e.uuid : o.mid, o.osVersion = e.osVersion ? e.osVersion : "", n.isIOS ? o.plat = 2 : o.plat = 1, i && i(o);
            });
          });
        });else if (n.isInClient() && n.isFXAP) n.mobileCall(625, null, function (t) {
          var r = JSON.parse(t.jsonStr);
          o.clientver = r.version, o.mid = r.mid, o.uuid = r.uuid ? r.uuid : o.mid, o.dfid = r.dfid ? r.dfid : "-", o.appid = r.appId, e.isiOS() ? o.plat = 2 : o.plat = 1, n.mobileCall(410, null, function (e) {
            1 == JSON.parse(e.jsonStr).status ? n.mobileCall(411, {}, function (e) {
              var n = JSON.parse(e.jsonStr).jsonStr ? JSON.parse(e.jsonStr).jsonStr : JSON.parse(e.jsonStr);
              o.userid = n.kugouId, o.token = n.token, o.pic = n.userLogo, o.nickName = n.nickName, i && i(o);
            }) : (o.userid = null, o.token = null, o.userpic = null, o.userNickName = null, i && i(o));
          });
        });else {
          o.appid = t || null, o.mid = e.getKgMid(), o.uuid = o.mid, o.plat = 4, o.dfid = e.Cookie.read("kg_dfid") || "-", o.userid = e.Cookie.read("KuGoo", "KugooID"), o.userpic = e.Cookie.read("KuGoo", "Pic"), o.userNickName = e.Cookie.read("KuGoo", "NickName"), o.token = e.Cookie.read("KuGoo", "t");
          var a = e.Cookie.read("KuGoo", "a_id");
          a && a != o.appid && (o.userid = null, o.token = null, o.userpic = null, o.userNickName = null), o.clientver = 1e3, o.userNickName = o.userNickName ? unescape(o.userNickName) : "", i && i(o);
        }
      };
    });
  });

  function infSign() {
    var getParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var callback,
        useH5 = false,
        isCDN = false,
        postType = "json",
        getData = _objectSpread2({}, getParams),
        isInClient = main_min.isInClient(); //兼容旧写法


    if (typeof options == "function") {
      callback = options;
    } else {
      callback = options.callback;
      useH5 = options.useH5 || false;
      postType = options.postType || "json";
      isCDN = options.isCDN || false;
    } //有POST且urlencoded情况下，客户端有BUG，强制降级


    if (postParams) {
      //降级
      if (Object.prototype.toString.call(postParams) != "[object Object]") {
        isInClient = false;
      } else if (postType == "urlencoded") {
        isInClient = false;
      }
    } //H5签名


    var oldCompatible = function oldCompatible() {
      var timestamp = new Date().getTime(),
          signArr = [],
          md5Arr = [],
          salt = "NVPh5oo715z5DIWAeQlhMDsWXXQV4hwt";

      if (isCDN) {
        delete publicData.clienttime;
        delete publicData.mid;
        delete publicData.uuid;
        delete publicData.dfid;
      }

      var publicData = {
        srcappid: "2919",
        clientver: "20000",
        clienttime: timestamp,
        mid: timestamp,
        uuid: timestamp,
        dfid: '-'
      };

      if (options && options.appkey) {
        // 业务动态传 appkey
        delete publicData.srcappid;
        salt = options.appkey;
      }

      main_min$1("", function (baseInfoRes) {
        publicData.clientver = baseInfoRes.clientver;
        publicData.mid = baseInfoRes.mid;
        publicData.uuid = baseInfoRes.uuid;
        publicData.dfid = baseInfoRes.dfid;
        getData = _objectSpread2({}, publicData, {}, getData);

        for (var i in getData) {
          signArr.push(i);
        }

        signArr.sort();
        signArr.forEach(function (v) {
          md5Arr.push(v + "=" + getData[v]);
        });

        if (postParams) {
          if (Object.prototype.toString.call(postParams) == "[object Object]") {
            if (postType == "json") {
              md5Arr.push(JSON.stringify(postParams));
            } else {
              var newpostParamsArr = [];

              for (var i in postParams) {
                newpostParamsArr.push(i + "=" + postParams[i]);
              }

              md5Arr.push(newpostParamsArr.join("&"));
            }
          } else {
            md5Arr.push(postParams);
          }
        }

        md5Arr.unshift(salt);
        md5Arr.push(salt);
        getData["signature"] = md5(md5Arr.join(""));

        if (options.log) {
          console.log("H5签名前参数排序结果", md5Arr);
          console.log("H5签名前md5原字符串", md5Arr.join(""));
          console.log("H5签名后返回", getData);
        }

        if (postParams) {
          callback && callback(getData, Object.prototype.toString.call(postParams) == "[object Object]" && postType == "json" ? JSON.stringify(postParams) : postParams);
        } else {
          callback && callback(getData);
        }
      });
    };

    if (isInClient && !useH5) {
      var execOne = false;
      main_min.mobileCall(764, {
        get: getData,
        post: postParams
      }, function (res) {
        //貌似多次回调
        if (execOne) {
          return false;
        }

        execOne = true;

        if (res && res.status) {
          delete res.status;

          if (options.log) {
            console.log("客户端签名前参数", {
              get: getData,
              post: postParams
            });
            console.log("客户端签名后返回", _objectSpread2({}, getData, {}, res));
          }

          getData = _objectSpread2({}, getData, {}, res);

          if (postParams) {
            callback && callback(getData, Object.prototype.toString.call(postParams) == "[object Object]" && postType == "json" ? JSON.stringify(postParams) : postParams);
          } else {
            callback && callback(getData);
          }

          return false;
        }

        isInClient = false; //当成旧版本处理

        oldCompatible();
      });
    } else {
      isInClient = false;
      oldCompatible();
    }
  }

  function openapiSign() {
    var getParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var postParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var salt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var callback,
        postType = "json",
        getData = _objectSpread2({}, getParams); //兼容旧写法


    if (typeof options == "function") {
      callback = options;
    } else {
      callback = options.callback;
      postType = options.postType || "json";
    } //H5签名


    var oldCompatible = function oldCompatible() {
      var signArr = [];
      var md5Arr = [];

      for (var i in getData) {
        signArr.push(i);
      }

      signArr.sort();
      signArr.forEach(function (v) {
        md5Arr.push(v + "=" + getData[v]);
      });

      if (postParams) {
        if (Object.prototype.toString.call(postParams) == "[object Object]") {
          if (postType == "json") {
            md5Arr.push(JSON.stringify(postParams));
          } else {
            var newpostParamsArr = [];

            for (var i in postParams) {
              newpostParamsArr.push(i + "=" + postParams[i]);
            }

            md5Arr.push(newpostParamsArr.join("&"));
          }
        } else {
          md5Arr.push(postParams);
        }
      }

      md5Arr.unshift(salt);
      md5Arr.push(salt);
      getData["signature"] = md5(md5Arr.join(""));

      if (options.log) {
        console.debug("sign: ", md5Arr.join(""));
        console.log("H5签名前参数", md5Arr);
        console.log("H5签名后返回", getData);
      }

      callback && callback(getData);
    };

    oldCompatible();
  }

  function createInstance(config) {
    var context = new KFCRequest(config);
    var instant = KFCRequest.prototype.request.bind(context);
    utils.extend(instant, KFCRequest.prototype, context);
    utils.extend(instant, context); // request interceptor： 参数签名

    instant.interceptors.request.on(function (config) {
      var promise = new Promise(function paramsSign(_callback) {
        var useH5 = false;

        if (config.sign == "h5") {
          useH5 = true;
        }

        if (!!config.isAllowSign) {
          if (config.sign == "openapi") {
            // openapi 签名方式
            openapiSign(config.params, config.data, config.signSalt, {
              postType: 'json',
              log: false,
              callback: function callback(publicParams) {
                config.params = publicParams;

                _callback(config);
              }
            });
          } else {
            infSign(config.params, config.data, {
              useH5: useH5,
              postType: 'json',
              log: config.signLog || false,
              appkey: config.signAppkey || null,
              callback: function callback(publicParams) {
                config.params = publicParams;

                _callback(config);
              }
            });
          }
        } else {
          _callback(config);
        }
      });
      return promise;
    }); // request interceptor： 上报日志

    instant.interceptors.request.on(function (config) {
      var promise = new Promise(function paramsSign(callback) {
        if (window.kmRequestListener) {
          // 上报日志
          window.kmRequestListener(1);
        }

        callback(config);
      });
      return promise;
    }); // response interceptor：重试

    instant.interceptors.response.on(undefined, function (response) {
      if (response && response.config && response.config.retry > 0) {
        var tempURL = response.config.baseURL;
        response.config.baseURL = response.config.retryURL;
        response.config.retryURL = tempURL;
        response.config.retry--;

        if (response.request) {
          response.request.abort();
          response.request = null;
        }

        if (response.config && response.config.params && response.config.params.signature) {
          delete response.config.params.signature;
        }

        return instant(response.config);
      } else {
        if (window.kmRequestListener) {
          // 上报日志，请求结束，重试完成，还是失败
          window.kmRequestListener(2, response.code || 0);
        }

        return Promise.reject(response);
      }
    }); // response interceptor：response data 格式化

    instant.interceptors.response.on(function (response) {
      try {
        response.data = JSON.parse(response.data);
      } catch (error) {}

      return response;
    }); // response interceptor：上报日志

    instant.interceptors.response.on(function (response) {
      if (window.kmRequestListener) {
        // 上报日志，请求成功
        window.kmRequestListener(2, 200);
      }

      return response;
    }); // response interceptor：风控

    instant.interceptors.response.on(function (response) {
      if (response.config.isAllowKGAntiBush && response && response.data && response.data.status === 0) {
        // 允许默认处理风控
        var eventid = "";
        var mid = "";

        try {
          // 注意，有一些情况拿不到，try一下，旧版本命令号就拿不到响应头
          eventid = response.headers["ssa-code"];
          mid = response.headers["ssa-hmid"];
        } catch (error) {}

        mid = mid ? mid : response.config.kgAntiBushMid || response.config.params.mid || "";
        var appid = response.config.kgAntiBushAppid || response.config.params.appid || "";

        if (!!eventid) {
          // 有eventid，拉起风控
          if (!!appid) {
            var curl = response.config.kgAntiBushURL ? response.config.kgAntiBushURL : "https://m3ws.kugou.com";
            curl = encodeURIComponent(curl);
            var antiHref = "https://h5.kugou.com/apps/verify-h5/dist/#/index/".concat(eventid, "/").concat(response.config.kgAntiBushAppid, "/").concat(curl, "/").concat(mid);
            window.location.replace(antiHref);
          } else {
            console.error("请输入正确的参数。eventid 和 appid 不允许为空！");
          }

          return null; // 风控了，跳转到风控，结束全部处理
        } else {
          return response;
        }
      }

      return response;
    });
    return instant;
  }

  var kfcRequest = createInstance(defaultConfig);
  return kfcRequest;
});